import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { isEmpty } from '../../Common/common';
import Editbox from '../../Part_Sample/Editbox';
import Management_Point_Selection_Cell from '../../Part_Sample/Management_Point_Selection_Cell';

export default class Add_Edit_Tenant extends Component {
	constructor(props) {
		super(props);

		let all_tenant_info = this.props.param.tenant_info; //contains all the tenant information
		let tenant_name = this.props.param.tenant_name == null ? '' : this.props.param.tenant_name; //name of the tenant selected
		let tenant_points_info = []; //contains only the points info of the selected tenant
		if (all_tenant_info != null) {
			if (all_tenant_info[tenant_name] != null) {
				tenant_points_info = all_tenant_info[tenant_name].points;
			}
		}

		let mp_list = {}; //status of the management point list
		if (!isEmpty(this.props.param.ppd_point_list)) {
			for (let i = 0; i < this.props.param.ppd_point_list.length; i++) {
				let id = this.props.param.ppd_point_list[i];
				mp_list[id] = {};
				mp_list[id].is_selected = false;
				if (tenant_points_info.length > 0) {
					if (tenant_points_info.includes(id)) {
						mp_list[id].is_selected = true;
					}
				}
			}
		}

		this.all_tenant_info = all_tenant_info;
		this.state = {
			tenant_name: tenant_name,
			mp_list: mp_list
		}
	}

	//Response from controller - loading all tenants information
	rcvLoadTenant(tenant_info) {
		window.app.hideLoading();
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('Tenant_Settings', { tenant_info: tenant_info == null ? null : tenant_info });
	}

	handlePrevious = () => {
		window.app.showLoading();
		this.props.receiver.loadTenant();
	}

	handleChangeTenantName = (tenant_name) => {
		if (this.props.param.from == 'edit_tenant') return;
		this.setState({ tenant_name: tenant_name })
	}

	//Toggle selection of the manangement points
	handleUpdateSelectedList = (id) => {
		let mp_list = this.state.mp_list;
		mp_list[id].is_selected = !mp_list[id].is_selected;
		this.setState({ mp_list: mp_list })
	}

	//Delete Tenant
	handleDelete = () => {
		let tenant_to_delete = this.state.tenant_name;
		delete this.all_tenant_info[tenant_to_delete];
		this.props.receiver.saveTenant(this.all_tenant_info);
	}

	//Save/Add Tenant
	handleRegister = () => {

		//Check if tenant name is empty
		if (this.state.tenant_name === "") {
			window.app.showToast(this.props.receiver.getString('ipcam_fillblanks'), 3000);
			return;
		}

		//Check if tenant name already exist - duplicated tenant name is not allowed
		if (this.props.param.from == 'add_tenant') {
			if (this.all_tenant_info.hasOwnProperty(this.state.tenant_name)) {
				window.app.showToast(this.props.receiver.getString('name_already_exists'), 3000);
				return;
			}
		}

		let points = [];
		//Check each device if is selected, if device is selected add into array
		for (var key in this.state.mp_list) {
			if (this.state.mp_list[key].is_selected) {
				points.push(key);
			}
		}

		if (this.all_tenant_info.hasOwnProperty(this.state.tenant_name)) {
			this.all_tenant_info[this.state.tenant_name].points = points;
		} else {
			this.all_tenant_info[this.state.tenant_name] = {};
			this.all_tenant_info[this.state.tenant_name].points = points;
		}

		this.props.receiver.saveTenant(this.all_tenant_info);
	}

	rcvSaveTenant = (response) => {
		if (response != null && response.result == 'OK') this.handlePrevious();
	}

	render() {

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.from == 'add_tenant' ? this.props.receiver.getString('add_tenant') : this.props.receiver.getString('edit_tenant')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div id="content_container" style={{ marginTop: 20, height: this.props.height - 120, overflow: 'auto', paddingBottom: window.innerHeight < window.innerWidth ? 100 : 0 }}>

						<div style={{ textAlign: 'center' }}>
							<Editbox id='tenant_name' style={{ width: this.props.width - 40, margin: 'auto' }} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangeTenantName(event.target.value)} value={this.state.tenant_name} />
						</div>

						<div style={{ textAlign: 'left', marginTop: 20, marginLeft: 20 }}>
							<span className='subtitle'>{this.props.receiver.getString('sel_device')}</span>
						</div>

						<div style={{ height: 'auto', paddingBottom: 20, overflow: 'auto' }}>

							{this.props.param.ppd_point_list.map((point_id, index) => {
								let point_info = window.app.state.point_list[point_id];
								if (!isEmpty(point_info)) {
									return (
										<Management_Point_Selection_Cell
											id={point_id}
											height={this.props.height}
											width={this.props.width}
											key={point_id}
											handleSetToggle={this.handleUpdateSelectedList}
											point_info={point_info}
											is_selected={this.state.mp_list[point_id].is_selected}
										/>
									)
								} else {
									return null;
								}

							})}
						</div>

					</div>
				</div>
			</div>
		)
	}
}